import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const patternFn = /* @__PURE__ */ createRecipe('pattern', {
  "size": "md"
}, [
  {
    "type": "square",
    "size": "sm",
    "css": {
      "backgroundSize": "calc(var(--pattern-spacing) * 7) calc(var(--pattern-spacing) * 7)",
      "backgroundPosition": "calc(var(--pattern-spacing) * -1) calc(var(--pattern-spacing) * -1)"
    }
  },
  {
    "type": "square",
    "size": "md",
    "css": {
      "backgroundSize": "calc(var(--pattern-spacing) * 9) calc(var(--pattern-spacing) * 9)",
      "backgroundPosition": "calc(var(--pattern-spacing) * -1.5) calc(var(--pattern-spacing) * -1.5)"
    }
  },
  {
    "type": "square",
    "size": "lg",
    "css": {
      "backgroundImage": "linear-gradient(var(--pattern-front-color) calc(var(--pattern-spacing) * 4), transparent calc(var(--pattern-spacing) * 4)),linear-gradient(to right, var(--pattern-front-color) calc(var(--pattern-spacing) * 4), transparent calc(var(--pattern-spacing) * 4))",
      "backgroundSize": "calc(var(--pattern-spacing) * 10) calc(var(--pattern-spacing) * 10)",
      "backgroundPosition": "calc(var(--pattern-spacing) * 2) calc(var(--pattern-spacing) * 2)"
    }
  },
  {
    "type": "diagonal",
    "size": "lg",
    "css": {
      "background": "repeating-linear-gradient(45deg, var(--pattern-front-color), var(--pattern-front-color) calc(var(--pattern-spacing) * 6.5), var(--pattern-back-color) calc(var(--pattern-spacing) * 6.5), var(--pattern-back-color) calc(var(--pattern-spacing) * 13))"
    }
  },
  {
    "type": "diagonalReverse",
    "size": "lg",
    "css": {
      "background": "repeating-linear-gradient(-45deg, var(--pattern-front-color), var(--pattern-front-color) calc(var(--pattern-spacing) * 6.5), var(--pattern-back-color) calc(var(--pattern-spacing) * 6.5), var(--pattern-back-color) calc(var(--pattern-spacing) * 13))"
    }
  }
])

const patternVariantMap = {
  "type": [
    "horizontal",
    "vertical",
    "diagonal",
    "diagonalReverse",
    "crossDot",
    "dot",
    "square",
    "cross",
    "grid",
    "gridBold"
  ],
  "size": [
    "sm",
    "md",
    "lg"
  ]
}

const patternVariantKeys = Object.keys(patternVariantMap)

export const pattern = /* @__PURE__ */ Object.assign(memo(patternFn.recipeFn), {
  __recipe__: true,
  __name__: 'pattern',
  __getCompoundVariantCss__: patternFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: patternVariantKeys,
  variantMap: patternVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, patternVariantKeys)
  },
  getVariantProps: patternFn.getVariantProps,
})